import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
var fileDownload = require("js-file-download");
import axios from "axios";
import { request } from "@/js/http/http_request.js";
import { hasRole, isAdminNotConsultant, getClientAppData } from "@/js/http/auth.js";
import { listTerms, paymentState, inboundDeliveryStatus, IMPORTER, orderStatus } from "@/js/lists.ts";
import { getFullNameUserHtml, userGroupName } from "@/js/user/user.js";
import { getSymbolCurrency as _getSymbolCurrency, formatPrice, roundToTwoDigit } from "@/js/currency/currencies.js";
import { getErrorData } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { isSameAddress } from "@/js/address.js";
import Address from "@/components/address/Address.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import WineNaming from "@/components/products/WineNaming.vue";
import SendMailModal from "@/components/mail/SendMailModal.vue";
import InboundDeliveryAttachedFilesDrawer from "@/components/inbound/AdminInboundDeliveryAttachedFilesDrawer.vue";
import InboundDeliveryPaymentList from "@/components/inbound/InboundDeliveryPaymentList.vue";
import Comment from "@/components/comment/CommentComponent.vue";
export default {
  name: "AdminInboundDeliveryDetails",
  components: {
    Address: Address,
    Confirm: Confirm,
    WineNaming: WineNaming,
    SendMailModal: SendMailModal,
    InboundDeliveryAttachedFilesDrawer: InboundDeliveryAttachedFilesDrawer,
    InboundDeliveryPaymentList: InboundDeliveryPaymentList,
    Comment: Comment
  },
  props: {
    loggedUserData: Object,
    baseModel: Object
  },
  data: function data() {
    return {
      clientAppData: null,
      canManageUsers: false,
      inboundDelivery: {
        id: null,
        user: null,
        deliveryAddress: null,
        billingAddress: null,
        deliveryInstructions: "",
        currency: "",
        amountVatEuro: 0.0,
        totalAmountCurrencyIncludeShipping: 0.0,
        items: []
      },
      showAllOriginalOrders: false,
      isFetchingOriginalOrders: false,
      fromOrders: [],
      payment: {
        reference: null,
        type: null,
        microDepositsUrl: null
      },
      documents: [],
      attachedFiles: [],
      attachedWineFiles: [],
      attachedWineryFiles: [],
      fetchDocumentsToken: null,
      isDocumentsFetched: false,
      isLoadingDocuments: false,
      documentDialog: false,
      sameAddress: true,
      isEditingAddresses: false,
      isSavingAddresses: false,
      updateAddressesToken: null,
      bufferedAddresses: {
        deliveryAddress: null,
        billingAddress: null,
        isSameAddress: null
      },
      listCountries: [],
      listStates: [],
      isEditingDeliveryInstructions: false,
      updateDeliveryInstructionsToken: null,
      newDeliveryInstructions: "",
      isDeliveryInstructionsAsDefaultForUserAdress: false,
      importersAvailableForCountry: [],
      importersForSelector: [],
      isEditingImporter: false,
      importerSelectorSelected: null,
      changeOrderImporterCancellationToken: null,
      updateTrackingToken: null,
      isEditingTracking: false,
      isUpdatingTracking: false,
      trackingForm: {
        inputTrackingNumber: null,
        inputTrackingUrl: null,
        valid: false
      },
      dialogChangeCarrierRef: false,
      paymentDialogStatusShown: false,
      isCollapsed: false,
      fetchInboundDeliveryToken: null,
      sendMailModalShown: false,
      isExportingXlsFreight: false,
      orderStatus: orderStatus,
      inboundDeliveryStatus: inboundDeliveryStatus,
      listTerms: listTerms,
      paymentState: paymentState,
      rules: formRules
    };
  },
  computed: {
    isConcernedByVat: function isConcernedByVat() {
      var _this$inboundDelivery;
      return ((_this$inboundDelivery = this.inboundDelivery) === null || _this$inboundDelivery === void 0 ? void 0 : _this$inboundDelivery.amountVatEuro) > 0;
    },
    nbBottles: function nbBottles() {
      var _this$inboundDelivery2;
      return (_this$inboundDelivery2 = this.inboundDelivery) === null || _this$inboundDelivery2 === void 0 || (_this$inboundDelivery2 = _this$inboundDelivery2.items) === null || _this$inboundDelivery2 === void 0 ? void 0 : _this$inboundDelivery2.reduce(function (acc, item) {
        return acc + item.quantity;
      }, 0);
    },
    documentCount: function documentCount() {
      var _this$documents;
      return (_this$documents = this.documents) === null || _this$documents === void 0 ? void 0 : _this$documents.reduce(function (acc, x) {
        return acc + x.children.length;
      }, 0);
    },
    textDueDate: function textDueDate() {
      if (this.inboundDelivery.paymentState != this.paymentState.SUCCEEDED && this.inboundDelivery.dueDate && this.isShipped) {
        var result = "";
        if (this.isCustomerHorecaUs && !this.isDelivered) {
          result += "Estimated due date : ";
        } else {
          result += "Due date : ";
        }
        result += new Date(this.inboundDelivery.dueDate).formatDate();
        return result;
      }
    },
    canManageInboundDelivery: function canManageInboundDelivery() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_DELIVERIES);
    },
    userData: function userData() {
      return String.parseForVHtml(getFullNameUserHtml(this.inboundDelivery.user)) + "<br /><span class='text-smaller text-italic'>" + userGroupName(this.inboundDelivery.user) + (this.inboundDelivery.user.sponsorship_code ? " - " + this.inboundDelivery.user.sponsorship_code : "") + "</span>";
    },
    isShipped: function isShipped() {
      return inboundDeliveryStatus.filter(function (x) {
        return ["DELIVERY", "DELIVERED"].includes(x.id);
      }).map(function (x) {
        return x.status;
      }).includes(this.inboundDelivery.status);
    },
    isDelivered: function isDelivered() {
      return inboundDeliveryStatus.find(function (x) {
        return x.id === "DELIVERED";
      }).status === this.inboundDelivery.status;
    },
    isCancelled: function isCancelled() {
      return this.inboundDelivery.status == inboundDeliveryStatus.find(function (x) {
        return x.id === "CANCELLED";
      }).status;
    },
    isTrackingEditable: function isTrackingEditable() {
      return !this.isEditingTracking && this.inboundDelivery.status !== inboundDeliveryStatus.find(function (x) {
        return x.id === "CANCELLED";
      }).status && this.inboundDelivery.status !== inboundDeliveryStatus.find(function (x) {
        return x.id === "DELIVERED";
      }).status;
    },
    deliveryInstructionsEditable: function deliveryInstructionsEditable() {
      return this.inboundDeliveryStatus.find(function (x) {
        return x.id == "DELIVERED";
      }).status != this.inboundDelivery.status && this.inboundDeliveryStatus.find(function (x) {
        return x.id == "CANCELLED";
      }).status != this.inboundDelivery.status;
    },
    canEditImporter: function canEditImporter() {
      var _this2 = this;
      return this.importersAvailableForCountry.some(function (x) {
        var _this2$inboundDeliver;
        return x.id != ((_this2$inboundDeliver = _this2.inboundDelivery.importer) === null || _this2$inboundDeliver === void 0 ? void 0 : _this2$inboundDeliver.id);
      }) && this.inboundDeliveryStatus.filter(function (x) {
        return ["AWAITING_VALIDATION", "AWAITING_CUSTOMER_VALIDATION", "ADJUSTING", "VALIDATED"].includes(x.id);
      }).map(function (x) {
        return x.status;
      }).includes(this.inboundDelivery.status);
    },
    isCustomerHorecaUs: function isCustomerHorecaUs() {
      var _this$inboundDelivery3, _this$inboundDelivery4, _this$inboundDelivery5, _this$inboundDelivery6;
      return (((_this$inboundDelivery3 = this.inboundDelivery) === null || _this$inboundDelivery3 === void 0 || (_this$inboundDelivery3 = _this$inboundDelivery3.user) === null || _this$inboundDelivery3 === void 0 ? void 0 : _this$inboundDelivery3.user_group) === "HORECA" || ((_this$inboundDelivery4 = this.inboundDelivery) === null || _this$inboundDelivery4 === void 0 || (_this$inboundDelivery4 = _this$inboundDelivery4.user) === null || _this$inboundDelivery4 === void 0 ? void 0 : _this$inboundDelivery4.user_group) === "WHOLESALER" || ((_this$inboundDelivery5 = this.inboundDelivery) === null || _this$inboundDelivery5 === void 0 || (_this$inboundDelivery5 = _this$inboundDelivery5.user) === null || _this$inboundDelivery5 === void 0 ? void 0 : _this$inboundDelivery5.user_group) === "ADMIN") && ((_this$inboundDelivery6 = this.inboundDelivery) === null || _this$inboundDelivery6 === void 0 || (_this$inboundDelivery6 = _this$inboundDelivery6.deliveryAddress) === null || _this$inboundDelivery6 === void 0 ? void 0 : _this$inboundDelivery6.country.iso_code) === "USA";
    },
    totalPaymentAmountCurrency: function totalPaymentAmountCurrency() {
      var amount = 0;
      this.inboundDelivery.payments.filter(function (x) {
        return x.state == paymentState.SUCCEEDED;
      }).forEach(function (x) {
        amount += x.amount;
      });
      return amount;
    },
    remainingPaymentAmount: function remainingPaymentAmount() {
      return roundToTwoDigit(this.inboundDelivery.totalAmountCurrencyIncludeShipping) - roundToTwoDigit(this.totalPaymentAmountCurrency);
    }
  },
  created: function created() {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this3.canManageUsers = hasRole(process.env.VUE_APP_ROLES_MANAGE_USER);
            _this3.clientAppData = getClientAppData(_this3);
            _this3.inboundDelivery = _objectSpread({}, _this3.baseModel);
            _this3.initPayment();
            _this3.sameAddress = isSameAddress(_this3.inboundDelivery.deliveryAddress, _this3.inboundDelivery.billingAddress);
            if (_this3.sameAddress) {
              _this3.inboundDelivery.billingAddress = _objectSpread({}, _this3.inboundDelivery.deliveryAddress);
            }
            _this3.fetchCountry();
            _this3.fetchDocuments();
            _this3.fetchOriginalOrder();
            if (!_this3.isShipped) {
              _this3.fetchImportersAvailableForCountry();
            }
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    fetchOriginalOrder: function fetchOriginalOrder() {
      var _this = this;
      this.isFetchingOriginalOrders = true;
      request("/v1/inbound/delivery/".concat(this.inboundDelivery.id, "/order"), "get", null, true, "api").then(function (response) {
        _this.fromOrders = _toConsumableArray(response.data);
        _this.isFetchingOriginalOrders = false;
      });
    },
    getOrderDetailsLink: function getOrderDetailsLink(orderId) {
      return {
        name: "adminOrderSummary",
        params: {
          id: orderId
        }
      };
    },
    initPayment: function initPayment() {
      var _this$inboundDelivery7;
      if (((_this$inboundDelivery7 = this.inboundDelivery) === null || _this$inboundDelivery7 === void 0 || (_this$inboundDelivery7 = _this$inboundDelivery7.payments) === null || _this$inboundDelivery7 === void 0 ? void 0 : _this$inboundDelivery7.length) > 0) {
        this.payment = this.inboundDelivery.payments[this.inboundDelivery.payments.length - 1];
      } else {
        this.payment = {
          id: null,
          methodId: null,
          paymentId: null,
          type: null,
          reference: null,
          microDepositsUrl: null
        };
      }
    },
    fetchCountry: function fetchCountry() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this4;
              _context2.next = 3;
              return request("/v1/countries?implantedMarket=true", "post", _this.clientAppData, false, "api").then(function (response) {
                _this.listCountries = _toConsumableArray(response.data.countries);
                _this.listStates = _toConsumableArray(response.data.states);
              }).catch(function (err) {
                _this.$toasted.show("An error occured. Please contact an administrator.", {
                  type: "error"
                });
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchDocuments: function fetchDocuments() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this5$fetchDocuments, _response$data;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this5.isLoadingDocuments = true;
              (_this5$fetchDocuments = _this5.fetchDocumentsToken) === null || _this5$fetchDocuments === void 0 || _this5$fetchDocuments.cancel();
              _this5.fetchDocumentsToken = axios.CancelToken.source();
              _this = _this5;
              _context3.next = 6;
              return request("/v1/inbound/delivery/".concat(_this5.inboundDelivery.id, "/docs"), "get", null, true, "api", null, _this5.fetchDocumentsToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to fetch documents.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  _this.isLoadingDocuments = false;
                }
              });
            case 6:
              response = _context3.sent;
              if (_this.isLoadingDocuments && response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.value) {
                _this5.documents = response.data.value.filter(function (x) {
                  var _x$document_urls;
                  return ((_x$document_urls = x.document_urls) === null || _x$document_urls === void 0 ? void 0 : _x$document_urls.length) > 0;
                }).reduce(function (acc, x) {
                  return [].concat(_toConsumableArray(acc), [_objectSpread(_objectSpread({}, x), {}, {
                    children: _toConsumableArray(x.document_urls)
                  })]);
                }, []);
                _this5.isDocumentsFetched = true;
                _this.isLoadingDocuments = false;
              }
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    openDocument: function openDocument(item) {
      window.open(item.url, "_blank");
    },
    saveAddress: function saveAddress() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this6$updateAddresse;
        var _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this6.isSavingAddresses = true;
              (_this6$updateAddresse = _this6.updateAddressesToken) === null || _this6$updateAddresse === void 0 || _this6$updateAddresse.cancel();
              _this6.updateAddressesToken = axios.CancelToken.source();
              _this = _this6;
              _context4.next = 6;
              return request("/v1/inbound/delivery/".concat(_this6.inboundDelivery.id, "/addresses"), "put", {
                deliveryAddress: _this.inboundDelivery.deliveryAddress,
                billingAddress: _this.inboundDelivery.billingAddress
              }, true, "api", null, _this6.updateAddressesToken).then(function (_) {
                _this.isEditingAddresses = false;
                _this.isDocumentsFetched = false;
              }).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to update addresses.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                }
              });
            case 6:
              _this6.isSavingAddresses = false;
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    addressChange: function addressChange() {
      if (this.sameAddress) {
        this.inboundDelivery.billingAddress = _objectSpread({}, this.inboundDelivery.deliveryAddress);
      }
    },
    cancelAddresses: function cancelAddresses() {
      this.isEditingAddresses = false;
      this.inboundDelivery = _objectSpread(_objectSpread({}, this.inboundDelivery), {}, {
        deliveryAddress: this.bufferedAddresses.deliveryAddress
      });
      this.inboundDelivery = _objectSpread(_objectSpread({}, this.inboundDelivery), {}, {
        billingAddress: this.bufferedAddresses.billingAddress
      });
      this.sameAddress = this.bufferedAddresses.isSameAddress;
    },
    editAddresses: function editAddresses() {
      this.isEditingAddresses = true;
      this.bufferedAddresses = {
        deliveryAddress: _objectSpread({}, this.inboundDelivery.deliveryAddress),
        billingAddress: _objectSpread({}, this.inboundDelivery.billingAddress),
        isSameAddress: this.sameAddress
      };
    },
    startEditDeliveryInstructions: function startEditDeliveryInstructions() {
      var _this7 = this;
      this.isEditingDeliveryInstructions = true;
      this.newDeliveryInstructions = this.inboundDelivery.deliveryInstructions;
      this.$nextTick(function (_) {
        _this7.$refs.inputDeliveryInstruction.focus();
      });
    },
    updateDeliveryInstructions: function updateDeliveryInstructions() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this8$updateDelivery;
        var _this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              (_this8$updateDelivery = _this8.updateDeliveryInstructionsToken) === null || _this8$updateDelivery === void 0 || _this8$updateDelivery.cancel();
              _this8.updateDeliveryInstructionsToken = axios.CancelToken.source();
              _this = _this8;
              _context5.next = 5;
              return request("/v1/inbound/delivery/".concat(_this8.inboundDelivery.id, "/delivery-instructions"), "put", {
                DeliveryInstructions: _this.newDeliveryInstructions,
                isSetAsDefaultForUserAddress: _this.isDeliveryInstructionsAsDefaultForUserAdress
              }, true, "api", null, _this8.updateDeliveryInstructionsToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to update delivery instructions.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                }
              });
            case 5:
              _this8.isEditingDeliveryInstructions = false;
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    startEditTracking: function startEditTracking() {
      var _this$inboundDelivery8;
      this.trackingForm.inputTrackingNumber = (_this$inboundDelivery8 = this.inboundDelivery) === null || _this$inboundDelivery8 === void 0 || (_this$inboundDelivery8 = _this$inboundDelivery8.trackingNumber) === null || _this$inboundDelivery8 === void 0 ? void 0 : _this$inboundDelivery8.toUpperCase();
      this.trackingForm.inputTrackingUrl = this.inboundDelivery.trackingUrl;
      this.isEditingTracking = true;
    },
    cancelTracking: function cancelTracking() {
      this.trackingForm.inputTrackingNumber = this.inboundDelivery.trackingNumber;
      this.trackingForm.inputTrackingUrl = this.inboundDelivery.trackingUrl;
      this.isEditingTracking = false;
    },
    updateTracking: function updateTracking() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this9$updateTracking;
        var _this;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this9.isUpdatingTracking = true;
              _this9.isEditingTracking = false;
              (_this9$updateTracking = _this9.updateTrackingToken) === null || _this9$updateTracking === void 0 || _this9$updateTracking.cancel();
              _this9.updateTrackingToken = axios.CancelToken.source();
              _this = _this9;
              _context6.next = 7;
              return request("/v1/inbound/delivery/".concat(_this.inboundDelivery.id, "/tracking"), "put", {
                TrackingNumber: _this.trackingForm.inputTrackingNumber,
                TrackingUrl: _this.trackingForm.inputTrackingUrl
              }, true, "api", null, _this9.updateTrackingToken).then(function () {
                _this.inboundDelivery.trackingNumber = _this.trackingForm.inputTrackingNumber.toUpperCase();
                _this.inboundDelivery.trackingUrl = _this.trackingForm.inputTrackingUrl;
              }).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to update tracking.", {
                    type: "error"
                  });
                  return;
                }
              });
            case 7:
              _this9.isUpdatingTracking = false;
            case 8:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    showPaymentStatusDialog: function showPaymentStatusDialog(value) {
      this.paymentDialogStatusShown = value;
    },
    updatePaymentStatus: function updatePaymentStatus(paymentState, paymentType, paymentDate, paymentReference) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this = _this10;
              _context7.prev = 1;
              if (!_this10.payment.id) {
                _context7.next = 7;
                break;
              }
              _context7.next = 5;
              return request("/v1/payment/".concat(_this10.payment.id), "put", {
                state: paymentState,
                type: paymentType,
                paymentDate: paymentDate,
                reference: paymentReference
              }, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to update the payment status.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                throw e;
              });
            case 5:
              _context7.next = 9;
              break;
            case 7:
              _context7.next = 9;
              return request("/v1/payment", "post", {
                inboundDeliveryId: _this10.inboundDelivery.id,
                state: paymentState,
                type: paymentType,
                paymentDate: paymentDate,
                reference: paymentReference,
                amount: _this10.inboundDelivery.totalAmountCurrencyIncludeShipping
              }, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to update the payment status.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                throw e;
              });
            case 9:
              _this10.showPaymentStatusDialog(false);
              _context7.next = 12;
              return _this10.fetchInboundDelivery();
            case 12:
              _this10.$toasted.show("Payment status changed.", {
                type: "success"
              });
              _context7.next = 17;
              break;
            case 15:
              _context7.prev = 15;
              _context7.t0 = _context7["catch"](1);
            case 17:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[1, 15]]);
      }))();
    },
    wineDetails: function wineDetails(wineId) {
      var routeParams = {};
      return {
        name: "userWineDetails",
        params: {
          id: wineId,
          readOnly: true,
          routeParams: routeParams
        }
      };
    },
    collapse: function collapse() {
      this.isCollapsed = !this.isCollapsed;
      var _this = this;
      this.$nextTick(function () {
        document.querySelector("#inbound-delivery-summary").scrollIntoView({
          behavior: "smooth",
          block: _this.isCollapsed ? "start" : "end"
        });
      });
    },
    fetchInboundDelivery: function fetchInboundDelivery() {
      var _arguments = arguments,
        _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this11$fetchInboundD;
        var isUpdatingPayments, _this, response;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              isUpdatingPayments = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
              (_this11$fetchInboundD = _this11.fetchInboundDeliveryToken) === null || _this11$fetchInboundD === void 0 || _this11$fetchInboundD.cancel();
              _this11.fetchInboundDeliveryToken = axios.CancelToken.source();
              _this = _this11;
              _context8.next = 6;
              return request("/v1/inbound/delivery/".concat(_this11.inboundDelivery.id), "get", null, true, "api", null, _this11.fetchInboundDeliveryToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to fetch the order.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  throw e;
                }
              });
            case 6:
              response = _context8.sent;
              if (response) {
                _this11.inboundDelivery = response.data.value;
                _this11.initPayment();
                if (isUpdatingPayments) {
                  _this11.$refs.inboundDeliveryPaymentList.updatePayments(_this11.inboundDelivery.payments);
                }
              }
            case 8:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    fetchImportersAvailableForCountry: function fetchImportersAvailableForCountry() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this, data, response;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this = _this12;
              data = {
                countryDestination: _this12.inboundDelivery.deliveryAddress.country.id_country,
                customerTypeDestination: IMPORTER.getimporterCustomerTypeIdFromUserGroup(_this12.inboundDelivery.user.user_group)
              };
              _context9.next = 4;
              return request("/v1/importers/all", "post", data, true, "api").catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load importers available");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 4:
              response = _context9.sent;
              if (response) {
                _this12.importersAvailableForCountry = response.data.value.items;
                _this12.createListImportersForSelector();
              }
            case 6:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    createListImportersForSelector: function createListImportersForSelector() {
      var _this13 = this,
        _this$inboundDelivery9;
      this.importersForSelector = _toConsumableArray(this.importersAvailableForCountry.filter(function (x) {
        var _this13$inboundDelive;
        return x.id !== ((_this13$inboundDelive = _this13.inboundDelivery.importer) === null || _this13$inboundDelive === void 0 ? void 0 : _this13$inboundDelive.id);
      }));
      if (((_this$inboundDelivery9 = this.inboundDelivery.importer) === null || _this$inboundDelivery9 === void 0 ? void 0 : _this$inboundDelivery9.id) > 0) {
        this.importersForSelector.unshift(this.inboundDelivery.importer);
      }
    },
    startEditImporter: function startEditImporter() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this14.isEditingImporter = true;
              _this14.createListImportersForSelector();
              _this14.importerSelectorSelected = _this14.importersForSelector[0];
            case 3:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    saveChangeImporter: function saveChangeImporter() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _this15$inboundDelive;
        var _this15$changeOrderIm, _this;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (!(((_this15$inboundDelive = _this15.inboundDelivery.importer) === null || _this15$inboundDelive === void 0 ? void 0 : _this15$inboundDelive.id) !== _this15.importerSelectorSelected.id)) {
                _context11.next = 8;
                break;
              }
              (_this15$changeOrderIm = _this15.changeOrderImporterCancellationToken) === null || _this15$changeOrderIm === void 0 || _this15$changeOrderIm.cancel();
              _this15.changeOrderImporterCancellationToken = axios.CancelToken.source();
              _this = _this15;
              _context11.next = 6;
              return request("/v1/inbound/delivery/".concat(+_this15.inboundDelivery.id, "/importer"), "put", {
                importerId: _this15.importerSelectorSelected.id
              }, true, "api", null, _this15.changeOrderImporterCancellationToken).then(function (_) {
                _this.inboundDelivery.importer = _this.importersForSelector.find(function (x) {
                  return x.id === _this15.importerSelectorSelected.id;
                });
                _this.isDocumentsFetched = false;
                _this.isEditingImporter = false;
              }).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to change importer");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  _this.isEditingImporter = false;
                }
              });
            case 6:
              _context11.next = 9;
              break;
            case 8:
              _this15.isEditingImporter = false;
            case 9:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    updateInboundWhenPaymentUpdated: function updateInboundWhenPaymentUpdated(payments) {
      this.inboundDelivery.payments = _toConsumableArray(payments);
    },
    goToUserEdit: function goToUserEdit(user) {
      return {
        name: "adminUserDetails",
        query: {
          id_user: user.id_user
        }
      };
    },
    getSymbolCurrency: function getSymbolCurrency() {
      return this.inboundDelivery.currency ? _getSymbolCurrency(this.inboundDelivery.currency) : "";
    },
    openAttachedFilesDrawer: function openAttachedFilesDrawer() {
      this.$refs.InboundDeliveryAttachedFilesDrawerRef.openDrawer();
    },
    openSendMailModal: function openSendMailModal() {
      var _this16 = this;
      this.sendMailModalShown = true;
      this.$nextTick(function () {
        _this16.$refs.SendMailModal.open();
      });
    },
    closeSendMailModal: function closeSendMailModal() {
      var _this17 = this;
      this.$nextTick(function () {
        _this17.sendMailModalShown = false;
      });
    },
    exportXlsFreight: function exportXlsFreight() {
      var _this18 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var url, fileName, _this, response;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _this18.isExportingXlsFreight = true;
              url = "/v1/inbound/delivery/".concat(+_this18.inboundDelivery.id, "/xls-freight");
              fileName = "".concat(+_this18.inboundDelivery.id, "_XLS_FREIGHT_DISPATCH.xlsx");
              _this = _this18;
              _context12.next = 6;
              return request(url, "get", null, true, "api", "blob").catch(function (e) {
                _this.isExportingXlsFreight = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to export file");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                throw e;
              });
            case 6:
              response = _context12.sent;
              fileDownload(response.data, fileName, "application/xlsx");
              _this18.isExportingXlsFreight = false;
            case 9:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    isAdminNotConsultant: isAdminNotConsultant,
    formatPrice: formatPrice
  }
};